export const services = [
  {
    id: 'aile-terapisi',
    slug: '/aile-terapisi',
    icon: 'ri-home-heart-line',
    title: 'Aile Terapisi',
    shortDesc: 'Aile içi çatışmaları çözün, bağları güçlendirin.',
    color: '#F5E6D0',
  },
  {
    id: 'cift-evlilik-danismanligi',
    slug: '/cift-evlilik-danismanligi',
    icon: 'ri-couple-line',
    title: 'Çift / Evlilik Danışmanlığı',
    shortDesc: 'İlişkinizi yeniden inşa edin, birbirinizi yeniden keşfedin.',
    color: '#F0E6F0',
  },
  {
    id: 'bireysel-danismanlik',
    slug: '/bireysel-danismanlik',
    icon: 'ri-user-heart-line',
    title: 'Bireysel Danışmanlık',
    shortDesc: 'Kendinizi keşfedin, iç dünyanızla barışın.',
    color: '#E6F0E8',
  },
  {
    id: 'cocuk-ergen',
    slug: '/cocuk-ergen-danismanligi',
    icon: 'ri-seedling-line',
    title: 'Çocuk & Ergen Danışmanlığı',
    shortDesc: 'Çocuğunuzun duygusal gelişimine destek olun.',
    color: '#E6EEF5',
  },
  {
    id: 'cinsel-terapi',
    slug: '/cinsel-terapi',
    icon: 'ri-heart-pulse-line',
    title: 'Cinsel Terapi',
    shortDesc: 'Güvenli bir alan, dürüst bir diyalog, gerçek bir iyileşme.',
    color: '#F5EEE6',
  },
  {
    id: 'bosanma-yas',
    slug: '/bosanma-yas-sureci',
    icon: 'ri-leaf-line',
    title: 'Boşanma ve Yas Süreci',
    shortDesc: 'Kaybın acısını anlayın ve yeni bir başlangıç yapın.',
    color: '#EEF0E6',
  },
];